var initUpload = function () {

    $("#uploadButton").on('click', function () {
        var formData = new FormData();
        var totalFiles = document.getElementById("fileUploader").files.length;
        for (var i = 0; i < totalFiles; i++)
        {
            var file = document.getElementById("fileUploader").files[i];

            formData.append("fileUploader", file);
        }
        formData.append("formId", $("#FormId").val());
        formData.append("businessId", $("#BusinessId").val());
        formData.append("responseId", $("#ResponseId").val());
        formData.append("topic", $("#Topic").val());
        formData.append("userId", $("#UserId").val());
        $.ajax({
            type: "POST",
            url: '/api/sitecore/DocStorage/UploadFile',
            data: formData,
            dataType: 'html',
            contentType: false,
            processData: false,
            success: function (response) {
               
                $('#documentList').html(response);
                $('#fileUploader').val('');
            },
            error: function (xhr,ajaxOptions,thrownError) {
                alert(xhr.responseText);
                //alert('Upload process failed... File size limit (10M)');
            }
        });
    });

   
};

function deleteDocument(item) {
    var sure = confirm("Click OK to confirm delete!");
    if (sure === true) {
        var url = '/api/sitecore/DocStorage/DeleteDocument';
        $.post(url, { guid:item,
            formId:$("#FormId").val(),
            businessId: $("#BusinessId").val(),
            responseId: $("#ResponseId").val(),
            topic: $("#Topic").val(),
            userId: $("#UserId").val()
        }, function (data) {
            $("#documentList").html(data);
        });
    }
}
       